import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
import _ from "lodash";

export const isReviewQueueSubscribed = (rqConfig, rqType) => {
  return rqConfig.find(({ type }) => type === rqType);
};

export const identitySpecDataHandler = (
  selectedRowsMap,
  map,
  action,
  reason,
  comments
) => {
  const includes = [];
  const excludes = [];
  const uuid = uuidv4();
  const time = moment(new Date())
    .tz(map.user.preferences.timeZone)
    .format("L, LTS z");
  for (let [k, v] of selectedRowsMap) {
    const [entityId, sourceSystemId] = k.split("+");
    if (v.operation === "include") {
      includes.push({ sourceSystemId, entityId });
    } else if (v.operation === "exclude") {
      excludes.push({ sourceSystemId, entityId });
    }
  }
  const data = {
    action: "IdentitySpecRequest",
    identitySpec: {
      identity_spec_id: map.primarySpecId
        ? `${map.clientId}|${map.primarySpecId}`
        : `${map.clientId}|${uuid}`,
      client_id: map.clientId,
      id: map.primarySpecId ? map.primarySpecId : uuid,
      include: includes,
      exclude: excludes,
      created_time: time,
      last_updated_time: time,
      last_modified_by: map.user.username,
      notes: `action=${action},reason=${reason},additionalcomments=${comments}`
    },
    targetGID: map.targetGID
  };
  return data;
};

export const actionCountsHandler = map => {
  const obj = {
    includeToPrimary: 0,
    excludeFromPrimary: 0,
    selectedPrimaryRecords: 0
  };
  for (let [, v] of map) {
    if (v.operation === "include") {
      if (!v.identitySpecID) obj.includeToPrimary++;
      if (v.table === "primary") obj.selectedPrimaryRecords++;
    } else if (v.operation === "exclude") {
      if (!v.identitySpecID) obj.excludeFromPrimary++;
    }
  }
  return obj;
};

export const toggler = (
  selectedRows,
  currentSelectdrow,
  type,
  preSelectedRowsMap
) => {
  const clonedMap = new Map(selectedRows);

  if (
    clonedMap.get(currentSelectdrow.original.id) &&
    clonedMap.get(currentSelectdrow.original.id).operation === type
  ) {
    clonedMap.delete(currentSelectdrow.original.id);
  } else if (
    clonedMap.get(currentSelectdrow.original.id) &&
    clonedMap.get(currentSelectdrow.original.id).operation !== type
  ) {
    if (
      preSelectedRowsMap.get(currentSelectdrow.original.id) &&
      preSelectedRowsMap.get(currentSelectdrow.original.id).operation === type
    ) {
      clonedMap.set(currentSelectdrow.original.id, {
        operation: type,
        table: currentSelectdrow.original.table,
        identitySpecID: preSelectedRowsMap.get(currentSelectdrow.original.id)
          .identitySpecID
      });
    } else {
      clonedMap.set(currentSelectdrow.original.id, {
        operation: type,
        table: currentSelectdrow.original.table
      });
    }
  } else {
    if (
      preSelectedRowsMap.get(currentSelectdrow.original.id) &&
      preSelectedRowsMap.get(currentSelectdrow.original.id).operation === type
    ) {
      clonedMap.set(currentSelectdrow.original.id, {
        operation: type,
        table: currentSelectdrow.original.table,
        identitySpecID: preSelectedRowsMap.get(currentSelectdrow.original.id)
          .identitySpecID
      });
    } else {
      clonedMap.set(currentSelectdrow.original.id, {
        operation: type,
        table: currentSelectdrow.original.table
      });
    }
  }
  return clonedMap;
};

export const linkAllToggler = (
  selectedRows,
  records,
  preSelectedRowsMap,
  selectAll
) => {
  const clonedMap = new Map(selectedRows);

  if (!selectAll) {
    records.forEach(record => {
      if (clonedMap.get(record.id)) {
        clonedMap.delete(record.id);
      }
    });
    return clonedMap;
  }

  records.forEach(record => {
    if (
      clonedMap.get(record.id) &&
      clonedMap.get(record.id).operation === "exclude"
    ) {
      if (
        preSelectedRowsMap.get(record.id) &&
        preSelectedRowsMap.get(record.id).operation === "exclude"
      ) {
        clonedMap.set(record.id, {
          operation: "include",
          table: record.table,
          identitySpecID: preSelectedRowsMap.get(record.id).identitySpecID
        });
      } else {
        clonedMap.set(record.id, {
          operation: "include",
          table: record.table
        });
      }
    } else {
      if (
        preSelectedRowsMap.get(record.id) &&
        preSelectedRowsMap.get(record.id).operation === "include"
      ) {
        clonedMap.set(record.id, {
          operation: "include",
          table: record.table,
          identitySpecID: preSelectedRowsMap.get(record.id).identitySpecID
        });
      } else {
        clonedMap.set(record.id, {
          operation: "include",
          table: record.table
        });
      }
    }
  });
  return clonedMap;
};

export const isPreSelectedRowsChanged = (
  selectedRowsMap,
  preSelectedRowsMap
) => {
  let selectedValue;
  if (selectedRowsMap.size !== preSelectedRowsMap.size) {
    return true;
  }
  for (let [recordId, preSelectedValue] of preSelectedRowsMap) {
    selectedValue = selectedRowsMap.get(recordId);
    if (
      !selectedValue ||
      (selectedValue &&
        (selectedValue.operation !== preSelectedValue.operation ||
          selectedValue.table !== preSelectedValue.table))
    ) {
      return true;
    }
  }
  return false;
};

export const isSameObject = (object1, object2, comparisonAttribute) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  if (comparisonAttribute) {
    if (object1[comparisonAttribute] !== object2[comparisonAttribute]) {
      return false;
    }
  }
  return true;
};

export const isEmptyAddress = obj => {
  return (
    _.isEmpty(obj.line) &&
    _.isEmpty(obj.city) &&
    _.isEmpty(obj.state) &&
    _.isEmpty(obj.country) &&
    _.isEmpty(obj.district) &&
    _.isEmpty(obj.postalCode)
  );
};

export const isEmptyName = obj => {
  return _.isEmpty(obj.family) && _.isEmpty(obj.given) && _.isEmpty(obj.suffix);
};

export const isEmptyTelecom = obj => {
  return _.isEmpty(obj.system) && _.isEmpty(obj.value);
};

export const isEmptyIdentifier = obj => {
  return _.isEmpty(obj.system) && _.isEmpty(obj.value) && _.isEmpty(obj.type);
};
